import styled from 'styled-components'

import { RadioButton, TypeStyle } from '@syconium/little-miss-figgy'

import { Label, inputFillsAncestor } from '../../../primitives/shared-form-styles'

export const ColorOptionsHeader = styled(Label)`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  margin-bottom: ${o => o.theme.spacing(3)};
  line-height: 20px;
`

export const TooltipButton = styled.button`
  align-items: center;
  display: inline-flex;
`

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(3)};
`

export const OptionRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;

  ${inputFillsAncestor}

  &:has(input:focus-visible) {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

export const OptionRadio = styled(RadioButton)`
  color: ${o => o.theme.color.text.primary.on.background};
`

export const OptionPrice = styled(TypeStyle.HeadlineMicro)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  font-size: 13px;
`
